import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditableField } from "../../../components/editable-field";
import { DateField } from "../../../components/date-field";
import { Button } from "../../../components/button";
import { CompetitionPricesAPI } from "../../../APIs/competition_prices.api";
import { toUTCDateString } from "../../../utils/date.utils";
import { useCompetitions } from "../../../context/CompetitionsContext";
import { useToast } from "../../../components/toast";
import {
  PaymentType,
  PaymentTypeTranslations,
} from "../../../types/payments.types";

export function PriceAddForm() {
  const navigate = useNavigate();
  const { currentCompetitionId } = useCompetitions();
  const { addToast } = useToast();

  const [formData, setFormData] = useState({
    price: 0,
    start_date: "",
    end_date: "",
    installment_count: 0,
    covers_platform_fee: false,
    platform_fee: 0,
    payment_type: undefined,
  });

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value, type } = e.target as HTMLInputElement;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? (e.target as HTMLInputElement).checked
          : type === "number"
          ? parseFloat(value)
          : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await CompetitionPricesAPI.createCompetitionPrice({
        ...formData,
        start_date: toUTCDateString(formData.start_date) || "",
        end_date: toUTCDateString(formData.end_date) || "",
        competition_id: Number(currentCompetitionId),
        payment_type: formData.payment_type! as PaymentType,
      });

      if (response.statusCode === 201) {
        addToast({
          type: "success",
          message: "Precio creado",
          location: "bottom-center",
        });
        navigate(-1);
      } else {
        addToast({
          type: "error",
          message: response.message,
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        type: "error",
        message: "Error al agregar el precio",
        location: "bottom-center",
      });
    }
  };

  return (
    <div className="m-8 p-8 max-w-2xl mx-auto border border-gray-300 rounded-md">
      <h1 className="text-2xl font-bold mb-6">Agregar Precio</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <EditableField
          label="Precio"
          name="price"
          type="number"
          value={formData.price}
          onChange={handleChange}
          required
        />

        <EditableField
          label="Número de cuotas"
          name="installment_count"
          type="number"
          value={formData.installment_count}
          onChange={handleChange}
          required
          min={1}
        />

        <DateField
          label="Fecha de inicio"
          name="start_date"
          value={formData.start_date}
          onChange={handleChange}
          required
          type="datetime-local"
        />

        <DateField
          label="Fecha de finalización"
          name="end_date"
          value={formData.end_date}
          onChange={handleChange}
          required
          type="datetime-local"
        />

        <EditableField
          label="Tipo de pago"
          name="payment_type"
          type="select"
          value={formData.payment_type}
          onChange={handleChange}
          required
          options={Object.entries(PaymentTypeTranslations).map(
            ([key, value]) => ({
              key,
              value,
            })
          )}
          placeholder="Seleccione el tipo de pago"
        />

        <EditableField
          label="Comisión de la plataforma"
          name="platform_fee"
          type="number"
          value={formData.platform_fee}
          onChange={handleChange}
        />

        <EditableField
          label="¿Asumir costos de la plataforma de pagos?"
          name="covers_platform_fee"
          type="checkbox"
          value={formData.covers_platform_fee}
          onChange={handleChange}
        />

        <div className="flex justify-end gap-4 mt-6">
          <Button
            type="button"
            variant="cancel"
            onClick={() => navigate(-1)}
            text="Cancelar"
          />
          <Button type="submit" variant="create" text="Agregar" />
        </div>
      </form>
    </div>
  );
}
